// src/App.js
import React from 'react';
import HomePage from './HomePage';

const App = () => {
  return (
    <div className="App">
      <HomePage />
    </div>
  );
};

export default App;
